import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["startDate", "endDate"]

  submit(event) {
    const start = this.startDateTarget.value
    const end = this.endDateTarget.value

    if (!start || !end) {
      event.preventDefault()
      alert("開始日と終了日を選択してください。")
      return
    }

    if (new Date(start) > new Date(end)) {
      event.preventDefault()
      alert("開始日は終了日より前の日付にしてください。")
      return
    }

    if (!confirm("指定した期間内のすべての公休日を削除します。よろしいですか？")) {
      event.preventDefault()
    }
  }
}
